import React, { useEffect, useState } from "react";
import { Polygon, InfoWindow } from "@react-google-maps/api";
import { api_get } from "services/api";
import { useSelector } from "react-redux";

const CoveragePolygons = ({ selectedUnit }) => {
  const [polygons, setPolygons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPolygon, setSelectedPolygon] = useState(null);
  const token = useSelector((state) => state.login.token);

  useEffect(() => {
    if (selectedUnit?.idStation && selectedUnit?.id) {
      fetchPolygons(selectedUnit.idStation, selectedUnit.id);
    }
  }, [selectedUnit]);

  const fetchPolygons = async (idStation, idUnit) => {
    setLoading(true);
    try {
      const auth = { headers: { authorization: `${token}` } };
      const url = `${process.env.REACT_APP_URL}/crm/routes/polygons/stations/${idStation}/units/${idUnit}`;
      const response = await api_get(url, auth);
      
      setPolygons(response || []);
    } catch (error) {
      console.error("Error fetching polygons:", error);
      setPolygons([]);
    } finally {
      setLoading(false);
    }
  };

  const convertPolygonCoords = (polygon) => {
    return polygon[0]?.map(coord => ({
      lat: coord.x,
      lng: coord.y
    })) || [];
  };

  const getPolygonOptions = (index) => ({
    fillColor: `hsl(${(index * 137.5) % 360}, 70%, 50%)`,
    fillOpacity: 0.3,
    strokeColor: `hsl(${(index * 137.5) % 360}, 70%, 40%)`,
    strokeOpacity: 0.8,
    strokeWeight: 2,
    clickable: true,
    draggable: false,
    editable: false,
    visible: true,
  });

  const getPolygonCenter = (coords) => {
    const latSum = coords.reduce((sum, coord) => sum + coord.lat, 0);
    const lngSum = coords.reduce((sum, coord) => sum + coord.lng, 0);
    return {
      lat: latSum / coords.length,
      lng: lngSum / coords.length
    };
  };

  if (loading || !polygons.length) return null;

  return (
    <>
      {polygons.map((polygonData, index) => {
        const coords = convertPolygonCoords(polygonData.polygon);
        return (
          <Polygon
            key={polygonData.id}
            paths={coords}
            options={getPolygonOptions(index)}
            onClick={() => setSelectedPolygon({ ...polygonData, coords, index })}
          />
        );
      })}
      {selectedPolygon && (
        <InfoWindow
          position={getPolygonCenter(selectedPolygon.coords)}
          onCloseClick={() => setSelectedPolygon(null)}
        >
          <div>
            <h4>{selectedPolygon.name}</h4>
            <p>{selectedPolygon.description}</p>
          </div>
        </InfoWindow>
      )}
    </>
  );
};

export default CoveragePolygons;